import { PROD_URL_HTTPS } from "./constants";

interface HeadResult {
  meta?: Record<string, string>[];
  links?: Record<string, string>[];
  scripts?: Record<string, string>[];
}

/**
 * Wraps a route's `head()` to add a canonical <link> when the CMS-resolved
 * seo block didn't provide one (true for every page except PDP, which
 * builds its own from VTEX product data). Canonical = own domain + path,
 * query string stripped (tracking/facet params shouldn't fragment indexing).
 */
export function withCanonicalFallback<Ctx>(
  headFn: (ctx: Ctx) => HeadResult,
) {
  return (ctx: Ctx): HeadResult => {
    const result = headFn(ctx);
    const hasCanonical = result.links?.some((l) => l.rel === "canonical");
    const pageUrl = (ctx as { loaderData?: { pageUrl?: string } } | undefined)
      ?.loaderData?.pageUrl;
    if (!hasCanonical && pageUrl) {
      try {
        const pathname = new URL(pageUrl).pathname;
        result.links = [
          ...(result.links ?? []),
          { rel: "canonical", href: `${PROD_URL_HTTPS}${pathname}` },
        ];
      } catch {
        // malformed pageUrl — skip, don't break the page over a missing canonical
      }
    }
    return result;
  };
}
